<template>
  <div>
    <div class="eig-filter clearfix">
      <div class="eig-rght pa-xs">
        <el-button
          type="primary"
          @click="addclassDialog"
        >添加分类</el-button>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="!isEdit?'新增分类':'编辑分类'"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="px-xs">
        <el-form
          :model="addClassForm"
          :rules="rules"
          ref="addClassFormRef"
          label-width="100px"
        >
          <el-form-item
            :label="!isEdit?'添加分类':'编辑分类'"
            prop="addclass"
          >
            <el-input v-model="addClassForm.addclass"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('addClassFormRef')"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-table
      ref="filterTable"
      :data="page.blogs"
      style="width: 100%"
      :default-sort="{prop: 'serial', order: 'descending'}"
    >
      <el-table-column
        type="index"
        label="序号"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="serial"
        label="权重"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="分类标题"
      ></el-table-column>
      <el-table-column
        prop="isShow"
        label="是否显示"
      >
        <template slot-scope="scope">
          <span>{{scope.row.isShow?'是':'否'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
      >
        <template slot-scope="scope">
          <!-- <el-button
            type="info"
            size="mini"
            @click="reply(scope.row)"
          >修改</el-button> -->
          <el-tooltip
            effect="dark"
            content="上移"
            placement="top"
          >
            <el-button
              size="small"
              icon="el-icon-top"
              circle
              @click="moveInfo(scope.row,scope.$index,'up')"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            content="下移"
            placement="top"
          >
            <el-button
              circle
              icon="el-icon-bottom"
              size="small"
              @click="moveInfo(scope.row,scope.$index,'down')"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              circle
              icon="el-icon-edit"
              size="small"
              @click="editInfo(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              circle
              size="small"
              icon="el-icon-delete"
              @click="deleteInfo(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :close-on-click-modal="false"
      title="删除"
      :visible.sync="dialogFormVisible"
      :lock-scroll="false"
      width="35%"
    >
      <span>是否删除 "{{deleteObj.title}}" </span>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="dialogFormVisible = false"
          size="small"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="haddledeleteInfo"
          size="small"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      // 绑定表单数据
      addClassForm: {
        id: "",
        addclass: "",
      },
      rules: {
        addclass: [
          {
            required: true,
            message: "请输入需要添加的类名称",
            trigger: "blur",
          },
          { min: 2, max: 10, message: "长度在 2 到 10个字符", trigger: "blur" },
        ],
      },
      // 分页
      page: {
        page_size: 5,
        page_index: 1,
        blogs: [],
        count: 0,
      },
      // 删除博客的数据对象
      deleteObj: {
        title: "",
        id: "",
      },
      // 控制弹窗
      dialogFormVisible: false,
      isEdit: false,
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    submitForm(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("/addclass", {
              id: this.addClassForm.id,
              title: this.addClassForm.addclass,
            })
            .then((res) => {
              if (res.status !== 200) {
                this.$message.error("发布失败");
                return;
              }
              this.addClassForm.id = "";
              this.addClassForm.addclass = "";
              this.$message.success("已发布");
              this.getInfo();
              this.dialogVisible = false;
              this.isEdit = false;
            })
            .catch((err) => {
              this.$message.error("发布失败");
              this.dialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }, // 占位符方式
    haddledeleteInfo() {
      this.$http
        .delete(`/deleteClass/?id=${this.deleteObj.id}`)
        .then((res) => {
          this.dialogFormVisible = false;
          this.page = {
            page_size: 5,
            page_index: 1,
            blogs: [],
            count: 0,
          };
          this.getInfo();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 弹出删除博客框
    deleteInfo(row) {
      console.log(row);
      this.deleteObj.id = row.id;
      this.deleteObj.title = row.title;
      this.dialogFormVisible = true;
    },
    // 获取分类
    getInfo() {
      const { page_index, page_size } = this.page;
      this.$http
        .get("/getClass", {
          params: {
            page_size,
            page_index,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.status !== 200) return;
          console.log(res.data);
          this.page.blogs = res.data.blogs;
          this.page.count = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 编辑
    editInfo(row) {
      this.addClassForm.id = row.id;
      this.addClassForm.addclass = row.title;
      this.isEdit = true;
      this.dialogVisible = true;
    },
    // 当前页改变
    handleCurrentChange(currentPageNumber) {
      console.log(currentPageNumber);
      this.page.page_index = currentPageNumber;
      this.getInfo();
    },
    // 当前每页数据量改变
    handleSizeChange(pageDataCount) {
      console.log(pageDataCount);
      this.page.page_size = pageDataCount;
      this.getInfo();
    },
    // 移动
    moveInfo(row, index, direction) {
      let tableData = this.$refs.filterTable.tableData;
      if (direction == "up") {
        if (index == 0) {
          return this.$message.info("无法再上移了！");
        }
        this.toMoveInfo(row, tableData[index - 1]);
      } else if (direction == "down") {
        if (index == this.page.blogs.length - 1) {
          return this.$message.info("无法再下移了！");
        }
        this.toMoveInfo(row, tableData[index + 1]);
      }
    },
    // 去移动
    toMoveInfo(upRow, downRow) {
      this.$http
        .post("/moveInfo", {
          upRow,
          downRow,
        })
        .then((res) => {
          if (res.status !== 200) {
            this.$message.error("移动失败");
            return;
          }
          this.getInfo();
        })
        .catch((err) => {
          this.$message.error("移动失败");
        });
    },
    addclassDialog() {
      this.isEdit = false;
      this.addClassForm.addclass = "";
      this.addClassForm.id = "";
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang='less' scoped>
</style>